var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"score-wrap"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('composer.scoreIndicatorTitle')))]),_c('div',{staticClass:"score"},[_c('div',{staticClass:"score__bar"},[_c('span',{style:({ transform: 'scale(' + _vm.barPos + ', 1)' })})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }